import moment from 'moment';
import CommonUtils from 'utilities/common-utils';
import { CustomViewsType, FilterType, ServiceType } from 'utilities/enum-utils';

export const defaultBookingViews = [
  {
    customViewId: 'ALL',
    name: 'All Bookings',
    isPinned: true,
    isDefault: true,
    viewType: CustomViewsType.EVERYONE,
    filterValue: [
      {
        filter: FilterType.DATE_RANGE,
        values: [moment().startOf('isoWeek'), moment().endOf('isoWeek')],
        selectionLabel: CommonUtils.getFilterText(FilterType.DATE_RANGE, [
          moment().startOf('isoWeek'),
          moment().endOf('isoWeek'),
        ]),
      },
      { filter: 'sort', values: [['startDateTime', 'asc']] },
      {
        filter: FilterType.CUSTOMER,
        values: [],
        selectionLabel: CommonUtils.getFilterSettings(FilterType.CUSTOMER).fullSelectionName,
      },
      {
        filter: FilterType.WORKER,
        values: [],
        selectionLabel: CommonUtils.getFilterSettings(FilterType.WORKER).fullSelectionName,
      },
      {
        filter: FilterType.SHIFT_SLOT_STATUS,
        values: [],
        selectionLabel: CommonUtils.getFilterSettings(FilterType.SHIFT_SLOT_STATUS).fullSelectionName,
      },
      {
        filter: FilterType.SERVICE_TYPE,
        values: [ServiceType.INDIVIDUAL],
        selectionLabel: 'Support services',
      },
    ],
  },
  {
    customViewId: 'NO_WORKER_CONFIRMED',
    name: 'No team members confirmed',
    isPinned: true,
    isDefault: true,
    viewType: CustomViewsType.EVERYONE,
    filterValue: [
      {
        filter: FilterType.DATE_RANGE,
        values: [],
        selectionLabel: CommonUtils.getFilterSettings(FilterType.DATE_RANGE).fullSelectionName,
      },
      {
        filter: FilterType.CUSTOMER,
        values: [],
        selectionLabel: CommonUtils.getFilterSettings(FilterType.CUSTOMER).fullSelectionName,
      },
      {
        filter: FilterType.WORKER,
        values: [],
        selectionLabel: CommonUtils.getFilterSettings(FilterType.WORKER).fullSelectionName,
      },
      {
        filter: FilterType.SHIFT_SLOT_STATUS,
        values: ['UNASSIGNED', 'PENDING'],
        selectionLabel: CommonUtils.getFilterText(FilterType.SHIFT_SLOT_STATUS, ['UNASSIGNED', 'PENDING', 'PUBLISHED']),
      },
      {
        filter: FilterType.BOOKING_STATUS,
        values: ['ACCEPTED', 'CONFIRMED', 'PENDING'],
        selectionLabel: CommonUtils.getFilterText(FilterType.BOOKING_STATUS, ['ACCEPTED', 'CONFIRMED', 'PENDING']),
      },
      {
        filter: FilterType.SERVICE_TYPE,
        values: [ServiceType.INDIVIDUAL],
        selectionLabel: 'Support services',
      },
      { filter: 'sort', values: [['startDateTime', 'asc']] },
    ],
  },
  {
    customViewId: 'OVERDUE',
    name: 'Overdue',
    isPinned: true,
    isDefault: true,
    viewType: CustomViewsType.EVERYONE,
    filterValue: [
      {
        filter: FilterType.DATE_RANGE,
        values: [moment().add(-1, 'year'), moment().startOf('day')],
        selectionLabel: CommonUtils.getFilterText(FilterType.DATE_RANGE, [
          moment().add(-1, 'year'),
          moment().startOf('day'),
        ]),
      },
      {
        filter: FilterType.CUSTOMER,
        values: [],
        selectionLabel: CommonUtils.getFilterSettings(FilterType.CUSTOMER).fullSelectionName,
      },
      {
        filter: FilterType.WORKER,
        values: [],
        selectionLabel: CommonUtils.getFilterSettings(FilterType.WORKER).fullSelectionName,
      },
      {
        filter: FilterType.BOOKING_STATUS,
        values: ['PENDING', 'ACCEPTED', 'CONFIRMED'],
        selectionLabel: CommonUtils.getFilterText(FilterType.BOOKING_STATUS, ['PENDING', 'ACCEPTED', 'CONFIRMED']),
      },
      {
        filter: FilterType.SERVICE_TYPE,
        values: [ServiceType.INDIVIDUAL],
        selectionLabel: 'Support services',
      },
      { filter: 'sort', values: [['startDateTime', 'asc']] },
    ],
  },
  {
    customViewId: 'REQUIRED_APPROVAL',
    name: 'Requires approval',
    isPinned: true,
    isDefault: true,
    viewType: CustomViewsType.EVERYONE,
    filterValue: [
      {
        filter: FilterType.DATE_RANGE,
        values: [],
        selectionLabel: CommonUtils.getFilterSettings(FilterType.DATE_RANGE).fullSelectionName,
      },
      {
        filter: FilterType.CUSTOMER,
        values: [],
        selectionLabel: CommonUtils.getFilterSettings(FilterType.CUSTOMER).fullSelectionName,
      },
      {
        filter: FilterType.WORKER,
        values: [],
        selectionLabel: CommonUtils.getFilterSettings(FilterType.WORKER).fullSelectionName,
      },
      {
        filter: FilterType.PAYMENT_STATUS,
        values: ['REQUIRES_APPROVAL'],
        selectionLabel: 'Requires approval',
      },
      {
        filter: FilterType.SERVICE_TYPE,
        values: [ServiceType.INDIVIDUAL],
        selectionLabel: 'Support services',
      },
      { filter: 'sort', values: [['startDateTime', 'asc']] },
    ],
  },
];
